/* eslint-disable react-hooks/exhaustive-deps */
import {  MouseEvent, useEffect } from "react"
import { HISTORY_TYPE, IHistoryStep, ILanding, ILandingSection, LANDING_EDIT_MODE, LANDING_PRIMITIVE_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingConsoleStore, ILandingStore, useLandingConsoleStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import { getLandingContainer } from "../../../utils/getLandingContainer"
import { useSyncState } from "src/modules/pe-basic-module/hooks/useSyncState"
import { ID } from "src/libs/interfaces/layouts"
import { getID } from "src/libs/utilities"
import updateSection from "../utils/updateSection"
import getSectionMousePosition from "../utils/getSectionMousePosition"
import useLandingSize from "src/modules/pe-landing-module/hooks/useLandingSize"

/* Protopia Ecosystem component */
export interface IFigureDrawFormProps {
   
}
const FigureDrawForm = (props: IFigureDrawFormProps): JSX.Element => {
    const currentLanding: ILanding          = useLandingStore((state: ILandingStore) => state.currentLanding)
    const editMode: LANDING_EDIT_MODE       = useLandingConsoleStore((state: ILandingConsoleStore) => state.editMode)
    const figureMode:LANDING_PRIMITIVE_TYPE = useLandingConsoleStore((state: ILandingConsoleStore) => state.figureMode)
    const color                             = useLandingConsoleStore((state: ILandingConsoleStore) => state.color) 
    const isDown                            = useSyncState<boolean>(false)
    const rect                              = useSyncState<DOMRect>({} as DOMRect) 
    const sectionId                         = useSyncState<ID>("") 

    const onClick = (evt: MouseEvent) => { 
        const landing: HTMLDivElement   = getLandingContainer() as HTMLDivElement 
        landing.style.userSelect= "none"
        const section = (evt.target as any).closest(".landing-section-container.landing-gap[id]")
        sectionId.set(section?.getAttribute("id") || "") 
        isDown.set(true)
        const pos = getSectionMousePosition(evt)
         
        rect.set({
            top:    pos.y , 
            width:  0,
            height: 0,
            left:   pos.x , 
        } as DOMRect)
        
    }
    const isSquareFigure = (): boolean => {
        return [ LANDING_PRIMITIVE_TYPE.STAR, LANDING_PRIMITIVE_TYPE.OVAL].includes( figureMode )
    }
    const onMove = (evt: MouseEvent) => {
        if(!isDown.get()) return 
        const pos = getSectionMousePosition(evt)
        const landing: HTMLDivElement   = getLandingContainer() as HTMLDivElement
        const landingPosition: DOMRect  = landing.getBoundingClientRect()
        const width  = - rect.get().left + pos.x
        const height = - rect.get().top + pos.y
        rect.set({
            top:    rect.get().top, 
            width,
            height: evt.ctrlKey || isSquareFigure() ? width : height,
            left:   rect.get().left, 
        } as DOMRect)
    }
    const onUp = (evt: MouseEvent) => {
        isDown.set(false)  
        console.log( rect.get(), sectionId.get() )
        const landing: HTMLDivElement  = getLandingContainer() as HTMLDivElement
        landing.style.userSelect= "auto"
        let newSection : ILandingSection = currentLanding.sections.find((section) => section.id === sectionId.get())!
        
        const contElement   = landing.querySelector( `.landing-section-container.landing-gap[id="${sectionId.get()}"] .landing-data-components-container` )!
        const contRect      = contElement.getBoundingClientRect()

        const step: IHistoryStep = {
            type: HISTORY_TYPE.SECTION,
            prevData: JSON.parse(JSON.stringify(newSection)),
            data: null,
            title: "Insert new float"
        }

        newSection = {
            ...newSection,
            floats: [
                ...newSection.floats,
                {
                    id: getID(),
                    position: {
                        width:  rect.get().width,
                        height: rect.get().height,
                        top:    rect.get().top,
                        left:   rect.get().left,
                    },
                    primitives: [
                        {
                            id: getID(),
                            type: figureMode,
                            fill: color,
                            position: {
                                width:  rect.get().width,
                                height: rect.get().height,
                            }
                        }
                    ]
                }
            ]
        }
        step.data = newSection
        updateSection( newSection, step )
        rect.set( {} as DOMRect )
        evt.preventDefault()
    }
    useEffect(() => {
        const landing: any  = getLandingContainer()
        if( editMode === LANDING_EDIT_MODE.PRIMITIVES ) {
            landing.addEventListener("mousedown", onClick)
            landing.addEventListener("mousemove", onMove)
            landing.addEventListener("mouseup", onUp)
        }
        return () => {
            landing.removeEventListener("mousedown", onClick)
            landing.removeEventListener("mousemove", onMove)
            landing.removeEventListener("mouseup", onUp)
        }
    }, [ editMode ])

    const landing: HTMLDivElement   = getLandingContainer() as HTMLDivElement
    const landingPosition: DOMRect  = landing?.getBoundingClientRect() 
    const contElement   = landing?.querySelector( `.landing-section-container.landing-gap[id="${sectionId.get()}"] .landing-data-components-container` )
    const contRect      = contElement?.getBoundingClientRect() 

    return editMode === LANDING_EDIT_MODE.PRIMITIVES && !landingPosition && !!contRect
        ?
        <div className='landing-figure-draw-form-container'>
            <div 
                className="landing-draw-rect" 
                style={{ 
                    ...rect.get(),
                    top:  rect.get().top  + contRect.top,
                    left: rect.get().left + contRect.left - landingPosition.left,
                }} 
            />
        </div>
        :
        <></>
}
export default FigureDrawForm